import "./cv.css";

const CV = () => {
  const fileUrl = `${process.env.PUBLIC_URL}/CVDmitry.pdf`;
  return <iframe className="cv-iframe" src={fileUrl} frameborder="0"></iframe>;
};

export default CV;
